/* eslint-disable @typescript-eslint/no-explicit-any */
import { IFileCreate } from "src/@types/file";
import { Tags } from "../enum/tags";
import { apiSlice } from "./http";
import { Paginated } from "src/@types/paginated";

interface SignedUrlParams {
  id: string;
  ResponseContentDisposition?: string;
  ContentType?: string;
}

interface DeleteFileParams {
  id: string;
}

export const fileInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadFile: builder.mutation<string, IFileCreate>({
      query: (file: IFileCreate) => {
        const formData = new FormData();
        formData.append("file", file.file);
        const auditParam = file.audit ? '?audit=true' : '';
        return {
          url: `/file/${file?.entity_name}/upload/${file?.entity_id}${auditParam}`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [Tags.FILE, Tags.CAN_CLOSE_CONCILIATION],
    }),
    publicUploadFile: builder.mutation<string, IFileCreate>({
      query: (file: IFileCreate) => {
        const formData = new FormData();
        formData.append("file", file.file);
        const auditParam = file.audit ? '?audit=true' : '';
        return {
          url: `/public/file/${file?.entity_name}/upload/${file?.entity_id}${auditParam}`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [Tags.FILE, Tags.CAN_CLOSE_CONCILIATION],
    }),
    getFiles: builder.query<
      Paginated<any>,
      { entity_name: string; id: string }
    >({
      query: (filters: { entity_name: string; id: string }) => {
        const params = new URLSearchParams(
          filters as unknown as Record<string, string>
        );

        return {
          url: `/file/${filters?.entity_name}?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.FILE],
    }),
    publicGetFiles: builder.query<
      Paginated<any>,
      { entity_name: string; id: string }
    >({
      query: (filters: { entity_name: string; id: string }) => {
        const params = new URLSearchParams(
          filters as unknown as Record<string, string>
        );

        return {
          url: `/public/file/${filters?.entity_name}?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.FILE],
    }),
    signedUrl: builder.mutation<{ url: string }, SignedUrlParams>({
      query: ({ id, ResponseContentDisposition, ContentType }) => {
        return {
          url: `/file/signed/${id}?`,
          method: "POST",
          headers: {
            ...(ResponseContentDisposition && {
              "Content-Disposition": ResponseContentDisposition,
            }),
            ...(ContentType && {
              "Content-Type": ContentType,
            }),
          },
        };
      },
      invalidatesTags: [Tags.CAN_CLOSE_CONCILIATION],
    }),
    deleteFile: builder.mutation<void, DeleteFileParams>({
      query: ({ id }) => ({
        url: `/file/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [Tags.FILE],
    }),
  }),
  overrideExisting: true,
});

export const {
  useUploadFileMutation,
  usePublicUploadFileMutation,
  useGetFilesQuery,
  usePublicGetFilesQuery,
  useSignedUrlMutation,
  useDeleteFileMutation,
} = fileInformations;

export const {
  endpoints: {
    uploadFile: { select: selectUploadFile },
    getFiles: { select: selectGetFiles },
    signedUrl: { select: selectSignedUrl },
    deleteFile: { select: selectDeleteFile },
  },
} = fileInformations;
